import axios from 'axios';
import { BACKEND_URL } from '../config_and_helpers/config';
import { logError, logInfo } from '../config_and_helpers/logger';
import { formatOcRequestErrors } from './oc_request_client';

const LOG_CONTEXT = 'organoid_culture_client';

const fail = (error, op) => {
  const data = error.response?.data ?? error.message;
  logError(LOG_CONTEXT, `${op} failed`, data);
  return {
    success: false,
    status: error.response?.status,
    messages: formatOcRequestErrors(data),
    error: data,
  };
};

/**
 * GET /organoid-cultures/
 */
export const getOrganoidCultures = async (token, options = {}) => {
  try {
    const params = new URLSearchParams();
    if (options.pageNum) params.set('page_num', String(options.pageNum));
    if (options.search) params.set('search', options.search);
    if (options.indication) params.set('indication', options.indication);
    if (options.activeOnly) params.set('active_only', 'true');
    const query = params.toString();
    const url = query
      ? `${BACKEND_URL}organoid-cultures/?${query}`
      : `${BACKEND_URL}organoid-cultures/`;
    logInfo(LOG_CONTEXT, 'getOrganoidCultures start');
    const response = await axios.get(url, {
      headers: { Authorization: `Token ${token}` },
    });
    return {
      success: true,
      data: response.data,
      results: response.data?.results ?? response.data ?? [],
      next: response.data?.next ?? null,
    };
  } catch (error) {
    return fail(error, 'getOrganoidCultures');
  }
};

/**
 * POST /organoid-cultures/
 */
export const createOrganoidCulture = async (token, payload) => {
  try {
    logInfo(LOG_CONTEXT, 'createOrganoidCulture start', { ocId: payload?.oc_id });
    const response = await axios.post(`${BACKEND_URL}organoid-cultures/`, payload, {
      headers: { Authorization: `Token ${token}` },
    });
    return { success: true, data: response.data };
  } catch (error) {
    return fail(error, 'createOrganoidCulture');
  }
};

/**
 * PATCH /organoid-cultures/{id}/
 */
export const patchOrganoidCulture = async (token, cultureId, payload) => {
  try {
    logInfo(LOG_CONTEXT, 'patchOrganoidCulture start', { cultureId });
    const response = await axios.patch(
      `${BACKEND_URL}organoid-cultures/${cultureId}/`,
      payload,
      { headers: { Authorization: `Token ${token}` } }
    );
    return { success: true, data: response.data };
  } catch (error) {
    return fail(error, 'patchOrganoidCulture');
  }
};
